<template>
  <tr>
    <td class="align-middle">
      {{ homeWork.name }}
    </td>

    <td class="align-middle">
      {{ homeWork.lesson }}
    </td>

    <td class="align-middle">
      {{ homeWork.btvn_count }}
    </td>

    <td class="align-middle">
      {{ studentCode }}
    </td>

    <td class="align-middle">
      {{ homeWork.phone }}
    </td>

    <!-- Trạng thái -->
    <td class="align-middle text-center">
      <el-button
          v-if="homeWork.status"
          :type="statusType"
          size="small"
          class="p-4 text-white w-100"
      >
        {{ homeWork.status_name }}
      </el-button>

      <span v-else>
        -
      </span>
    </td>

    <!-- Hình thức chấm -->
    <td class="align-middle text-center">
      <span v-if="!homeWork.test">
        -
      </span>

      <span
          v-else-if="
          homeWork.test.has_handmade_mark_test
        "
      >
        Chấm tự động &amp; GV chấm
      </span>

      <span v-else>
        Chấm tự động
      </span>
    </td>

    <!-- Deadline -->
    <td class="align-middle text-center">
      <span v-if="showDeadline">
        {{ homeWork.deadline || '-' }}
      </span>

      <span v-else>
        -
      </span>
    </td>

    <!-- Thời gian GV chấm -->
    <td class="align-middle text-center">
      <span v-if="showMarkTime">
        {{
          homeWork.test.updated_at
              | formatDateTimeVietnam
        }}
      </span>

      <span v-else>
        -
      </span>
    </td>

    <!-- Hành động -->
    <td class="align-middle text-center">
      <div
          v-if="homeWork.test"
          v-b-tooltip.hover
          title="Xem kết quả"
          class="btn btn-icon btn-xs btn-outline-success ml-1"
          @click="viewHomework"
      >
        <i class="far fa-eye" />
      </div>

      <div
          v-if="canMarkHomework"
          v-b-tooltip.hover
          title="Chấm lại bài tập"
          class="btn btn-icon btn-xs btn-outline-info ml-1"
          @click="actionMarkHomework"
      >
        <i class="fas fa-pen-nib" />
      </div>

      <div
          v-if="homeWork.is_history"
          v-b-tooltip.hover
          title="Lịch sử chấm của GV"
          class="btn btn-icon btn-xs btn-outline-info ml-1"
          @click="historyHomework"
      >
        <i class="fas fa-file-alt" />
      </div>

      <div
          v-if="canReopenHomework"
          v-b-tooltip.hover
          title="Làm lại bài tập về nhà"
          class="btn btn-icon btn-xs btn-outline-warning ml-1"
          @click="reopenHomework"
      >
        <i class="el-icon-refresh" />
      </div>
      <div v-b-tooltip.hover @click="$emit('resetHomework', homeWork)" v-if="canResetMark" title="Reset kết quả"
        class="btn btn-icon btn-xs btn-outline-danger ml-2">
        <i class="fas fa-undo"></i>
      </div>

      <span v-if="!hasAction">
        -
      </span>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'HomeWorkV2',

  props: {
    homeWork: {
      type: Object,
      required: true
    },

    learning_schedule_id: {
      type: [String, Number],
      default: null
    },

    lessonNumber: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      statusColorMap: {
        1: 'primary',
        2: 'info',
        3: 'success',
        4: 'warning'
      }
    }
  },

  computed: {
    canResetMark() {
      return this.homeWork.test
          && this.homeWork.test.has_handmade_mark_test
          && this.homeWork.status == 3;
    },

    studentCode() {
      const userId = Number(this.homeWork.user_id)

      return Number.isNaN(userId)
          ? '-'
          : userId + 100000
    },

    statusType() {
      return (
          this.statusColorMap[
              Number(this.homeWork.status)
              ] || 'info'
      )
    },

    showDeadline() {
      return Number(this.homeWork.status) !== 2
    },

    showMarkTime() {
      return Boolean(
          this.homeWork.test &&
          Number(this.homeWork.status) === 3 &&
          this.homeWork.test.updated_at
      )
    },

    canMarkHomework() {
      return Boolean(
          this.homeWork.test &&
          Number(this.homeWork.status) === 1
      )
    },

    canReopenHomework() {
      const homeworkType = Number(this.homeWork.type)
      const homeworkStatus = Number(
          this.homeWork.status
      )

      if (
          homeworkType === 0 ||
          homeworkType === 1
      ) {
        return true
      }

      return Boolean(
          this.homeWork.test &&
          !this.homeWork.test.has_handmade_mark_test &&
          homeworkStatus === 3
      )
    },

    hasAction() {
      return Boolean(
          this.homeWork.test ||
          this.homeWork.is_history ||
          this.canReopenHomework
      )
    }
  },

  methods: {
    getCommonQuery() {
      return {
        classroom_id: this.homeWork.classroom_id,
        learning_schedule_id:
        this.learning_schedule_id,
        student_id: this.homeWork.user_id,
        lesson: this.lessonNumber,
        center_id: this.$route.query.center_id
      }
    },

    viewHomework() {
      if (!this.homeWork.test) {
        return
      }

      const routeData = this.$router.resolve({
        name: 'content-homework-v2',

        params: {
          id: this.homeWork.classroom_id
        },

        query: {
          ...this.getCommonQuery(),
          type: 'view-result'
        }
      })

      window.open(routeData.href, '_blank')
    },

    actionMarkHomework() {
      if (!this.homeWork.test) {
        return
      }

      const routeData = this.$router.resolve({
        name: 'mark-homework-v2',

        params: {
          id: this.homeWork.classroom_id
        },

        query: {
          ...this.getCommonQuery(),
          overall_id:
          this.homeWork.test.overall_id
        }
      })

      window.open(routeData.href, '_blank')
    },

    historyHomework() {
      const routeData = this.$router.resolve({
        name: 'history-homework',

        params: {
          id: this.homeWork.classroom_id
        },

        query: {
          classroom_id:
          this.homeWork.classroom_id,
          lesson: this.lessonNumber,
          course_student_id:
          this.homeWork.course_student_id,
          student_id: this.homeWork.user_id,
          type: 'redo'
        }
      })

      window.open(routeData.href, '_blank')
    },

    reopenHomework() {
      this.$emit(
          'reopenHomework',
          this.homeWork
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/custom/custom-teacher-edu.scss";

.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mx-datepicker {
  width: 100% !important;
}
</style>
